/* Notes · página de produto: cor e tamanho, preço no botão, foto da variante, traços do carrossel,
   caixa de compra compacta ao rolar, sacola sem sair da página e setas dos relacionados. */
(function () {
  "use strict";
  if (window.NotesProduto) return;

  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function q(root, sel) { return root.querySelector(sel); }

  function contar(n) {
    qa(document, "[data-ns-cart-count]").forEach(function (el) { el.textContent = n; });
    qa(document, ".ns-cart, .ns-m__cart").forEach(function (el) { el.classList.toggle("has-items", n > 0); });
  }

  function initPdp(pdp) {
    var form = q(pdp, "[data-ns-form]");
    var fotos = q(pdp, "[data-ns-fotos]");
    var dots = q(pdp, "[data-ns-dots]");
    var figs = fotos ? qa(fotos, ".ns-pdp__foto") : [];

    /* ---------- carrossel (celular): traço da foto visível ---------- */
    function marcarDot() {
      if (!dots || !fotos || fotos.scrollWidth <= fotos.clientWidth) return;
      var i = Math.round(fotos.scrollLeft / fotos.clientWidth);
      qa(dots, "i").forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
    }
    if (fotos) {
      var pend = false;
      fotos.addEventListener("scroll", function () {
        if (pend) return; pend = true;
        requestAnimationFrame(function () { pend = false; marcarDot(); });
      }, { passive: true });
    }

    function irParaMedia(id) {
      if (!id || !fotos) return;
      var fig = figs.find(function (f) { return f.getAttribute("data-media") === String(id); });
      if (!fig) return;
      if (fotos.scrollWidth > fotos.clientWidth) {
        fotos.scrollTo({ left: fig.offsetLeft - fotos.offsetLeft, behavior: "smooth" });
      } else {
        var top = fig.getBoundingClientRect().top + window.scrollY - 76;
        if (fig.getBoundingClientRect().top < 64 || fig.getBoundingClientRect().bottom > window.innerHeight) {
          window.scrollTo({ top: top, behavior: "smooth" });
        }
      }
    }

    /* ---------- cor e tamanho ---------- */
    if (form) {
      var variants = [];
      try { variants = JSON.parse(q(pdp, "[data-ns-variants]").textContent); } catch (e) { variants = []; }
      var idInput = q(form, "[data-ns-id]");
      var btn = q(form, "[data-ns-btn]");
      var btnTxt = q(form, "[data-ns-btn-txt]");
      var preco = q(pdp, "[data-ns-preco]");

      function selecionada() {
        return qa(form, "[data-ns-opt]").map(function (fs) { var c = q(fs, "input:checked"); return c ? c.value : null; });
      }
      function atualizar(rolar) {
        if (!variants.length) return;
        var sel = selecionada();
        var v = variants.find(function (vv) { return sel.every(function (val, k) { return val === null || vv.opcoes[k] === val; }); });
        if (!v) {
          if (btn) { btn.disabled = true; btn.classList.add("is-off"); btnTxt.textContent = btn.getAttribute("data-off"); }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (preco) preco.textContent = v.preco;
        if (btn) {
          btn.disabled = !v.available;
          btn.classList.toggle("is-off", !v.available);
          btnTxt.textContent = v.available ? btn.getAttribute("data-label") + " — " + v.preco : btn.getAttribute("data-off");
        }
        if (rolar) irParaMedia(v.media);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", v.id);
          window.history.replaceState({}, "", url.toString());
        } catch (e) { /* sem histórico */ }
      }
      form.addEventListener("change", function () { atualizar(true); });
      atualizar(false);

      /* ---------- sacola sem sair da página ---------- */
      if (!form.hasAttribute("data-ns-ready")) {
        form.setAttribute("data-ns-ready", "");
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          if (!btn || btn.disabled) return;
          var antes = btnTxt.textContent;
          btn.disabled = true;
          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
            .then(function (r) { if (!r.ok) throw new Error("add"); return fetch("/cart.js"); })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              contar(cart.item_count);
              btnTxt.textContent = btn.getAttribute("data-ok") || "adicionado";
              setTimeout(function () { btnTxt.textContent = antes; }, 2000);
              document.dispatchEvent(new CustomEvent("ns:cart-updated", { detail: cart }));
            })
            .catch(function () { form.submit(); })
            .finally(function () { btn.disabled = false; });
        });
      }
    }

    /* ---------- caixa de compra compacta ao rolar ---------- */
    var pendRolar = false;
    window.addEventListener("scroll", function () {
      if (pendRolar) return; pendRolar = true;
      requestAnimationFrame(function () { pendRolar = false; pdp.classList.toggle("is-compact", window.scrollY > 140); });
    }, { passive: true });

    /* ---------- relacionados: setas ---------- */
    var lista = q(pdp, "[data-ns-rel-list]");
    if (lista) {
      function passo() { var c = q(lista, ".ns-pdp__card"); return c ? c.getBoundingClientRect().width + 16 : 200; }
      var prev = q(pdp, "[data-ns-rel-prev]"), next = q(pdp, "[data-ns-rel-next]");
      if (prev) prev.addEventListener("click", function () { lista.scrollBy({ left: -passo(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { lista.scrollBy({ left: passo(), behavior: "smooth" }); });
    }
  }

  window.NotesProduto = {
    init: function (root) {
      qa(root || document, "[data-ns-pdp]:not([data-ns-ready])").forEach(function (pdp) {
        pdp.setAttribute("data-ns-ready", "");
        initPdp(pdp);
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { window.NotesProduto.init(document); });
  } else {
    window.NotesProduto.init(document);
  }
  document.addEventListener("shopify:section:load", function (e) { window.NotesProduto.init(e.target); });
})();
